module.exports = __webpack_public_path__ + "img/profile_banner.430236dd.jpg";